/**
 * This is used to differentiate category pages, could be used for SearchCatNavBannersRequest and layout related proto
 * for now we want to differentiate new brand page and featured brand page
 */
export enum PageType {
  PAGE_TYPE_UNKNOWN = 'PAGE_TYPE_UNKNOWN',
  EXPLORE_PAGE = 'EXPLORE_PAGE',
  DISCOVER_PAGE = 'DISCOVER_PAGE',
}
